const resourcesEn = {
  translation: {
    Account: 'Account',
    AccountOptions: 'Account Options',
    AirTemperature: 'Air temperature',
    Alarm: 'Alarm',
    AlarmMessage: 'Alarm received',
    AnalitycsModeButtonLabel: 'Analytics mode',
    Analytics: 'Analytics',
    AncDepth: 'Anchorage Depth',
    Anchorage: 'Anchorage',
    Anchorages: 'Anchorages',
    Anchoring: 'Anchoring',
    AnchoringOrRemove: 'Anchoring/unmooring in the parking lot',
    AnyAnchorage: 'Any Anchorage',
    AnyArea: 'Any area',
    AnyPort: 'Any port',
    AnyVessel: 'Any vessel',
    APIKey: 'API-key',
    AppliedFilters: '(applied filters)',
    Apply: 'Apply',
    Area: 'Geozone',
    Areas: 'Geozones',
    AreasArea: 'Square',
    AreasVesselsAmount: 'Vessels in the Geozone',
    AreaVesselsTotal: 'Vessels in the Geozone',
    AtAnchorage: 'At Anchorage',
    ATBA: 'Areas to be avoided (ATBA)',
    ATD: 'ATD',
    Aton: 'AtoN',
    AtonDescription: 'AtoN',
    AtonInfo: 'AtoN information',
    Atons: 'AtoNs',
    AtonsPageHeader: 'AtoNs',
    AuthButtonLabel: 'Sign in',
    AverageSpeed: 'Average speed',
    AverageSpeedForMonth: 'Average speed in 30 days',
    AverageSpeedOnTheMoveForMonth: 'Average speed (in motion) in 30 days',
    BboxVesselsTotal: 'Vessels in this Geozone',
    BeachMoor: 'Beach Mooring',
    BreakBulk: 'Breakbulk',
    ButtonLabelAdd: 'Add',
    ButtonLabelAddVessel: 'Add vessel',
    ButtonLabelAddVesselToFleet: 'Add to fleet',
    ButtonLabelClose: 'Close',
    ButtonLabelCreate: 'Create',
    ButtonLabelDelete: 'Remove',
    ButtonLabelDiscard: 'Cancel',
    ButtonLabelDownloadHistory: 'Download position history',
    ButtonLabelExportCSV: 'CSV export',
    ButtonLabelExportSCV: 'CSV export',
    ButtonLabelImport: 'Import',
    ButtonLabelImportSCV: 'CSV import',
    ButtonLabelSave: 'Save',
    ButtonLabelToDiscard: 'Cancel',
    Calculate: 'Calculate',
    CalculatedETA: 'Calculated ETA',
    CallSign: 'Call sign',
    CargoDepth: 'Cargo Pier Depth',
    CargoFacilities: 'CargoFacilities',
    CatalogAtonsTotal: 'AtoN in the catalog',
    CatalogPortsTotal: 'Ports in the catalog',
    CatalogVesselsTotal: 'Vessels in the catalog',
    ChangeFilter: 'Change filter',
    ChangesSaved: 'Changes saved',
    ChannelDepth: 'Channel Depth',
    CheckboxLabelAllCountry: 'All flags',
    CheckboxLabelAllFleetGroup: 'All vessels and groups',
    CheckboxLabelAllStatus: 'All navigational statuses',
    CheckboxLabelAllType: 'All types',
    CheckCorrectnessAddress: 'Please ensure you have entered the correct address and try again',
    ChooseFile: 'Choose a file',
    ChosenVessel: 'Chosen vessel',
    Cht: 'Chemical Holding Tank Disposal',
    ClipboardCopy: 'Copy to clipboard',
    ClipboardCopySuccess: 'Value copied to clipboard',
    CollapseSidebar: 'Close menu',
    Color: 'Color',
    CommonAreasTitle: 'Common Geozones',
    CommonAreaTitle: 'Common Geozone',
    ConstructionAndOperation: 'Construction and operation',
    ConstructionDateFilter: 'Construction date',
    Contaiiner: 'Container',
    Coordinates: 'Coordinates',
    CoordinatesFormatOption: 'Coordinates format',
    Country: 'Flag',
    Course: 'Course',
    CreateNotification: 'Create a notification',
    CreationYear: 'Year built',
    CurrentPosition: 'Current position',
    DangCargoAncor: 'Dangerous Cargo Anchorage',
    DataIsLoading: 'Loading...',
    DataNotObtained: 'No data received',
    DataObtained: 'Data received',
    DataSourceLabel: 'Data source',
    Date: 'Date',
    DatePickerLabel: 'Date, time:',
    DatePickerPlaceholderText: 'Pick a date',
    DatePickerTimeCaption: 'Time',
    Day: 'Day',
    DaysOnTheMove: 'Days moving',
    DaysOnTheMoveSubValue: 'out of 30',
    DeadWeight: 'Deadweight',
    DegreesUnit: 'deg',
    DepartureFromPort: 'Departure',
    DeparturePort: 'Port of departure',
    Depth: 'Depth',
    Description: 'Description',
    Design: 'Design',
    Destination: 'Destination',
    DestinationAis: 'Destination AIS',
    DestinationPortKeyFilter: 'Destination port',
    DirtyBall: 'Dirty Ballast Disposal',
    Displacement: 'Displacement',
    Distance: 'Distance',
    Distances: 'Distances',
    DownloadReport: 'Download report',
    Draught: 'Draught',
    ECA: 'Emission control areas  (ECA)',
    Editor: 'Editor',
    EEZ: 'Exclusive economic zone (EEZ)',
    EgisPageTitle: 'СИТРОНИКС.ГИС',
    EmergencySignals: 'Emergency Signals',
    EnglishLanguage: 'English (EN)',
    EnteredTheGeozone: 'Entered The Geozone',
    EnteredYearError: 'The entered value must be between 0 and ',
    EntranceRestriction: 'Entrance Restriction',
    EntranceWidth: 'Entrance Width',
    Error_IsRequired: 'Is required',
    Error_NineDigits: 'Value must contain 9 digits',
    Error_OnlyNumbers: 'Value must contain only numbers',
    ErrorOperationOfService: 'Something has gone wrong',
    ETA: 'ETA \u2013 AIS',
    EtaFilterLabel: 'Arrival date',
    EventDate: 'Date',
    EventType: 'Event type',
    Feedback: 'Feedback',
    FieldPlaceholderGroupDescription: 'Group description',
    FieldPlaceholderGroupName: 'Group name',
    FieldPlaceholderMMSI: 'MMSI (9 digits)',
    FilesReview: 'Select...',
    FileUploadTitleCSV: 'Select a CSV-file with a list of MMSIs',
    Filter: 'Filter',
    FilterPanelButtonReset: 'Clear filters',
    FilterPanelButtonSubmit: 'OK',
    FilterPanelHeading: 'Filters',
    FilterPanelLabelCountries: 'Flag',
    FilterPanelLabelFleetGroup: 'Fleet and groups',
    FilterPanelLabelFleetOnly: 'Fleet only',
    FilterPanelLabelStatus: 'Navigational status',
    FirstPort: 'First Port of Entry',
    Flag: 'Flag',
    FleetLabel: 'Fleet',
    FleetVesselsTotal: 'Vessels in fleet',
    ForTheGeozone: 'Geozone',
    ForThePort: 'Port',
    ForTheVessel: 'Vessel',
    From: 'From',
    FromAsLimit: 'From',
    FromToValueError: 'The "from" value cannot be greater than the "to" value',
    FuelBunker: 'Fuel Bunker',
    FuelType: 'Fuel Type',
    GarbageDisp: 'Garbage Disposal',
    GeofenceName: 'Name',
    GeofenceNamePlaceholder: 'The Geozone name',
    GeofenceRemoved: 'The Geozone was removed',
    GeofenceRemoving: 'The Geozone removing',
    GeofenceRemovingDescription:
      '«{{name}}» Geozone will be removed.\nAll earlier created and linked to this geozone notification settings will be deleted too.\nYou cannot restore the Geozone and notification settings.\nAdd the Geozone and notification settings again if necessary.',
    GeofenceRemovingQuestion: 'Remove «{{name}}» Geozone?',
    GeofenceWktLabel: 'WKT Polygon',
    GeofenceWktPlaceholder: 'Enter WKT Polygon',
    GlobalSearchPlaceholder: 'Find vessels by IMO, MMSI, call sign or name',
    GoToTGBotPhrase: 'Go to the telegram bot by following the link',
    GrossTonnage: 'Gross Tonnage',
    GrossTonnageUnit: 'grt',
    Group: 'Group',
    GroupParametrs: 'Group settings',
    Groups: 'Groups',
    GyroCompass: 'Heading',
    Harbor: 'Harbor',
    HarborSize: 'Harbor Size',
    HarborType: 'Harbor Type',
    HarborUse: 'Harbor Use',
    HideWeather: 'Hide weather data',
    History: 'History',
    HistoryData: 'Historical data',
    Home: 'Home',
    HomePort: 'Port of registry',
    HoverTextAverageSpeedOnTheMove: 'Speed includes only periods when the vessel in  motion',
    HoverTextAverageSpeedTotal: 'Speed includes periods of standstill in ports, anchorages, etc.',
    IceClass: 'Ice Class',
    IceMoor: 'Ice Mooring',
    IMO: 'IMO',
    InactiveTag: '(inactive)',
    IncorrectCSVFileFormatError: 'Incorrect file format, please use CSV.',
    IncorrectGeofenceNameLenghtError: 'Name must be 1 to 256 symbols long',
    IncorrectGeofenceWKTError: 'Incorrect WKT string',
    IncorrectGroupNameLenghtError: 'Name must be 1 to 64 symbols long',
    IncorrectHeadingOrCogValueError: 'The entered value must be between 0 and 360.',
    IncorrectShipNoteLenghtError: 'Note must be 1 to 256 symbols long',
    Info: 'Info',
    Inmarsat: 'Inmarsat',
    InPortKeyFilter: 'In port',
    InTotal: 'Total',
    InvalidLatitude: 'Invalid latitude',
    Km: 'km',
    KmH: 'km/h',
    Language: 'Language',
    LastPosition: 'Last position',
    Latitude: 'Latitude',
    Layers: 'Layers',
    LeftAnchorage: 'Left anchorage',
    LeftTheGeozone: 'Left the Geozone',
    LengthBeam: 'Length / beam',
    LengthDimension: 'Length',
    Less: 'Less',
    LessThenHour: 'less then hour',
    LiquidBulk: 'Liquid Bulk',
    LLZ: 'Load Line Zones (LLZ)',
    LngTerm: 'LNG Terminal',
    LoadMore: 'Load more',
    LocalTime: 'Local time',
    Login: 'Login',
    Logout: 'Sign out',
    Longitude: 'Longitude',
    LowerTheAnchor: 'Arrival',
    LukoilPageTitle: 'Спутниковый мониторинг',
    MainEngine: 'The number and power of main engine',
    Map: 'Map',
    MarketPlaceLabel: 'Satellite images',
    MaximumDraft: 'Maximum Draft',
    MedFacili: 'Medical Facilities',
    MedMoor: 'Med Mooring',
    MeterUnit: 'm',
    MinZeroValueError: 'Value must be greater or equal than 0',
    MinZoomTitle: 'Map overview',
    MMSI: 'MMSI',
    ModalAddToFleetLabel: 'Use MMSI to add to fleet:',
    ModalDeleteFromFleetQuestion: 'Remove from fleet?',
    ModalDeleteNtfRuleQuestion: 'Remove?',
    ModalDeleteNtfRulesQuestion: 'Remove {{length}}?',
    ModalTitleAddToFleet: 'Add the vessels to the fleet',
    ModalTitleDeleteFromFleet: 'Delete fleet',
    ModalTitleDeleteNtfRule: 'Remove motification rule',
    ModalTitleImportToFleet: 'Fleet CSV import',
    Month: 'Month',
    Mooring: 'Mooring',
    More: 'More',
    MotionlessVessel: 'Motionless vessel',
    Name: 'Name',
    NauticalChart: 'Nautical chart',
    NavStatus: 'Nav. status',
    NearbyShips: 'Nearby Ships',
    NeedToAuth: 'Please sign in to continue.',
    NewGeofence: 'New Geozone',
    NewGroupName: 'New group',
    NewNotificationRule: 'New notification rule',
    NM: 'NM',
    NoFile: 'No file',
    NoGroup: 'No group',
    NoNotificationRules: 'No notification rules',
    NoNotifications: 'No notifications',
    NoPhoto: 'No photo',
    NoPlayBackData: 'No data to display, please select another date',
    NoPlaybackVesselData: 'No data to display.',
    NoResultsFound: 'No results found',
    Notes: 'Notes',
    NotFoundPage: '404: The page could not be found',
    Notification: 'Notification',
    NotificationDelivery: 'Notification delivery',
    Notifications: 'Notifications',
    NotificationSettings: 'Notification Settings',
    NotificationsList: 'Notifications list',
    NotificationsSettings: 'Settings',
    Notify: 'Notify',
    NoVesselsInFleet: 'No vessels in the fleet, add MMSI to begin.',
    Objects: 'Objects',
    OilTerm: 'Oil Terminal',
    OilTermDepth: 'Oil Terminal Depth',
    Others: 'Others',
    Owner: 'Owner',
    Perimeter: 'Perimeter',
    Period: 'Period',
    Photo: 'Photo',
    Port: 'Port',
    PortArrival: 'Arrival',
    PortArrivalsDateOption_24h: '24 hours',
    PortArrivalsDateOption_30d: '30 days',
    PortArrivalsDateOption_48h: '48 hours',
    PortArrivalsDateOption_72h: '72 hours',
    PortEvents: 'Recent Arrivals & Departures',
    PortInfo: 'Port information',
    PortSecur: 'Port Security',
    PortsPageHeader: 'Ports',
    PortTargetCatalog: 'Vessels in the port',
    PortTerminal: 'Port terminal',
    PortVesselsTotal: 'Vessels in the port',
    Position: 'Position',
    PowerPlantType: 'Type of power plant',
    PredictedPort: 'Port (predicted)',
    PreferredSettings: 'Preferred Settings',
    Pressure: 'Pressure',
    PressureHumidity: 'Pressure, humidity',
    PressureHumidityFull: 'Atmospheric pressure, humidity',
    PressureUnit: 'mm Hg',
    PropellerInfo: 'Propeller number, type',
    Proportion: 'Proportion',
    Platform: 'Platform',
    RaiseTheAnchor: 'Departure',
    Registration: 'Registration',
    Registry: 'Registry',
    RegistryNumber: 'Registry Number',
    ReloadOrSupport: 'Try to reload the page or contact the support',
    RemovingFromAnchorage: 'Removing From Anchorage',
    RestrIce: 'Entrance Restriction (Ice)',
    RestrOther: 'Entrance Restriction (Other)',
    RestrSwell: 'Entrance Restriction (Heavy Swell)',
    RestrTide: 'Entrance Restriction (Tide)',
    Roro: 'RoRo',
    RouteBuilderWarning: 'The route is for information only and should not be used for navigation',
    RulesWillBeDeleted:
      'The notification rules will be removed. You cannot restore the  notification rule. Create the notification rule again if necessary',
    RuleWillBeDeleted:
      'The notification rule will be removed. You cannot restore the  notification rule. Create the notification rule again if necessary',
    RussianLanguage: 'Русский (RU)',
    SatelliteView: 'Satellite',
    SearchingText: 'Searching...',
    SearchPlaceholder: 'Search',
    SelectAllVessels: 'Select all vessels',
    SelectArea: 'Select a geozone',
    SelectPort: 'Select a port',
    SelectVessel: 'Select a vessel',
    Service: 'Service',
    SettingLabelAutoRefresh: 'Update map automatically',
    SettingLabelShowGroupIndicator: 'Highlight fleet groups',
    SettingLabelShowLegend: 'Legend',
    SettingLabelShowPorts: 'Ports',
    SettingLabelShowRoutePredicted: 'Track forecast',
    SettingLabelShowRoutes: 'Past track',
    SettingLabelShowTerminals: ' Port terminals',
    SettingLabelShowVessels: 'Vessels',
    Settings: 'Settings',
    SeveralGroup: 'Multiple groups',
    Shipbuilder: 'Shipbuilder',
    ShipNote: 'Notes',
    ShipTypesLabel: 'Vessel types',
    ShowBboxVesselsTitle: 'Vessels on the map',
    ShowFiltersTitle: 'Filters',
    ShowOnMap: 'Show on the map',
    ShowRoute: 'Past track',
    ShowRoutePredicted: 'Track forecast',
    ShowSettingTitle: 'View settings',
    SiAISBot: 'SiAIS Bot',
    SimbolOfClass: 'RS Class notation',
    SimilarShips: 'Similar vessels',
    SogFilter: 'Sog',
    SolidBulk: 'Solid Bulk',
    Source: 'Source',
    SourceDescriptionSatellite: 'satellite AIS (S-AIS)',
    SourceDescriptionTerrestrial: 'terrestrial AIS (T-AIS)',
    SpecialAreasTitle: 'Special Geozones',
    SpecifiedArea: 'Specified area',
    SpecifiedPort: 'Specified port',
    Speed: 'Speed',
    SpeedPastTrack: 'Speed (past track)',
    SubscriptionTelegramNotificationsDisabled: 'Subscription to Telegram notifications is disabled',
    SubscriptionTelegramNotificationsEnabled: 'Subscription to Telegram notifications is enabled',
    SunriseSunset: 'Sunrise, sunset',
    Support: 'Support',
    Telegram: 'Telegram',
    TelegramNotificationWarning: 'Subscribe to telegram bot. Notifications are currently disabled',
    Temperature: 'Temperature',
    Terminal: 'Port Terminal',
    Terminals: 'Port Terminals',
    TerminalTargetCatalog: 'Vessels at the terrminal',
    TerminalVesselsTotal: 'Vessels at the terrminal',
    TheLatestMotionDate: 'The latest motion date',
    TidalRange: 'Tidal Range',
    TimeFormatOption: 'Time format',
    TimeOnRoute: 'Time on route',
    TimeZoneOption: 'Timezone',
    To: 'To',
    ToAsLimit: 'To',
    Token: 'Token',
    Total: 'Total',
    TrackedSince: 'Tracked since',
    TransponderClass: 'Transponder class',
    TravelledForDay: 'Travelled in 24 hours',
    TravelledForMonth: 'Travelled in 30 days',
    Type: 'Type',
    UserAreasTitle: 'User Geozones',
    UserAreaTitle: 'User Geozone',
    UserSettingsDeliveryStatusConfigured: 'Configured',
    UserSettingsDeliveryUnsubscribe: 'Unsubscribe',
    VectorMap: 'Map',
    Vessel: 'Vessel',
    VesselBeam: 'Maximum Vessel Beam',
    VesselCalls: 'Port calls',
    VesselCallsExpected: 'Ship calls are expected',
    VesselDraft: 'Maximum Vessel Draft',
    VesselInfo: 'Vessel information',
    VesselLength: 'Maximum Vessel Length',
    VesselPlayback: 'Playback',
    VesselsInArea: 'Vessels in the Geozone',
    VesselsNames: 'Vessels names',
    VesselsPageHeader: 'Vessels',
    VesselSpeedUnit: 'kn',
    VesselsWillBeDeleted: 'Vessels to remove: {{amount}}',
    VesselTypeCargo: 'Cargo vessel',
    VesselTypeCargoPlural: 'Cargo vessels',
    VesselTypeFishing: 'Fishing vessel',
    VesselTypeFishingPlural: 'Fishing vessels',
    VesselTypeOther: 'Other vessel',
    VesselTypeOtherPlural: 'Other vessels',
    VesselTypePassenger: 'Passenger vessel',
    VesselTypePassengerPlural: 'Passenger vessels',
    VesselTypePleasure: 'Leisure vessel',
    VesselTypePleasurePlural: 'Leisure vessels',
    VesselTypeSpecialTug: 'Special vessel, tug',
    VesselTypeSpecialTugPlural: 'Special vessels, tugs',
    VesselTypeSpeed: 'High-speed vessel',
    VesselTypeSpeedPlural: 'High-speed vessels',
    VesselTypeTanker: 'Tanker',
    VesselTypeTankerPlural: 'Tankers',
    VesselWillBeDeleted: 'The Vessel {{mmsi}} will be removed',
    Visibility: 'Visibility',
    Waves: 'Waves',
    Weather: 'Weather',
    Week: 'Week',
    WeightUnit: 't',
    Wharve: 'Wharves',
    WharvesAnchor: 'Wharves, Anchor',
    WidthDimension: 'Beam',
    Wind: 'Wind',
    WindBarbs: 'Wind barbs',
    WindGust: 'Wind gust',
    WindSpeedUnit: 'm/s',
    WorldFleet: 'World Fleet',
    ZoomInTipLabel: 'Zoom in',
    ZoomOutTipLabel: 'Zoom out',
  },
};

export default resourcesEn;
